module.exports = __webpack_public_path__ + "img/ico_field_cansel.d8dd65b8.svg";